import React, { Component } from "react";

class FieldCheckbox extends Component {
    constructor(props) {
        super(props);

        this.checkBlur = this.checkBlur.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    checkBlur() {
        this.props.onBlur(this.props.id, true);
    }

    checkSubmit() {}

    render() {
        let { fieldConfig, schema, setFieldValue } = this.props;

        let arrayValues =
            typeof fieldConfig.value === "object" ? fieldConfig.value : [];
        // console.log("arrayValues", fieldConfig.name, arrayValues);
        return (
            <div>
                {schema.enum.map((enumVal, i) => {
                    return (
                        <div
                            className="form-check"
                            key={`${fieldConfig.name}.${enumVal}`}
                        >
                            <input
                                className="form-check-input"
                                id={`${fieldConfig.name}.${enumVal}`}
                                name={`${fieldConfig.name}.${enumVal}`}
                                onBlur={fieldConfig.onBlur}
                                onChange={e => {
                                    // console.log(
                                    //     arrayValues,
                                    //     e.target.checked,
                                    //     enumVal
                                    // );
                                    if (
                                        e.target.checked &&
                                        arrayValues.indexOf(enumVal) === -1
                                    )
                                        arrayValues.push(enumVal);
                                    else {
                                        let i = arrayValues.indexOf(enumVal);
                                        arrayValues.splice(i, 1);
                                    }

                                    setFieldValue(
                                        fieldConfig.name,
                                        arrayValues
                                    );
                                }}
                                onSubmit={fieldConfig.onSubmit}
                                type="checkbox"
                                value={enumVal}
                                checked={arrayValues.includes(enumVal)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`${fieldConfig.name}.${enumVal}`}
                            >
                                {"enumNames" in schema
                                    ? schema.enumNames[i]
                                    : enumVal}
                            </label>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default FieldCheckbox;



// WEBPACK FOOTER //
// ./src/FieldCheckbox.js